import { useEffect, useState } from "react";
import { Alert, AlertTitle, Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { getEstadoConnect } from "../../actions/payments";

// Qué se le dice en cada caso: `pantalla` cierra el aviso en «Mis servicios» y en Reservas (con su botón) y `formulario` al publicar un
// servicio (sin botón); sin texto para el formulario, ahí no sale
const AVISOS = {
  sinCuenta: {
    titulo: "Conecta tu cuenta para recibir tus pagos",
    texto: "Lo que tus clientes pagan en línea te llega a tu banco por medio de Stripe.",
    pantalla: "Mientras no la conectes, ese dinero se queda guardado.",
    formulario: "Puedes publicar ahora y conectarla después en Perfil › Datos para pagos.",
  },
  aMedias: {
    titulo: "Termina de conectar tu cuenta para recibir tus pagos",
    texto: "A tu registro en Stripe le faltan algunos datos.",
    pantalla: "Mientras no lo termines, lo que te paguen tus clientes se queda guardado.",
    formulario: "Puedes publicar ahora y terminarlo después en Perfil › Datos para pagos.",
  },
  revisando: {
    titulo: "Stripe está revisando tu cuenta",
    texto: "Cuando la apruebe, tus pagos te llegarán en el siguiente corte semanal.",
    pantalla: "Mientras tanto, lo que te paguen tus clientes se queda guardado.",
    formulario: null,
  },
};

// Para quien todavía no puede recibir sus pagos: sin cuenta de Stripe conectada, con el registro a medias o mientras Stripe la revisa.
// Con la cuenta lista, si la plataforma no tiene Stripe o si no se pudo preguntar, no sale nada. `enFormulario`: sin botón, porque
// salir del formulario perdería lo escrito.
const AvisoCobro = ({ enFormulario = false, sx }) => {
  const navigate = useNavigate();
  const [estado, setEstado] = useState(null);

  useEffect(() => {
    let vigente = true;
    getEstadoConnect().then((data) => { if (vigente) setEstado(data); });
    return () => { vigente = false; };
  }, []);

  if (!estado || estado.disponible === false || estado.payoutsEnabled) return null;
  const caso = !estado.conectado ? "sinCuenta" : estado.detailsSubmitted ? "revisando" : "aMedias";
  const aviso = AVISOS[caso];
  const cierre = enFormulario ? aviso.formulario : aviso.pantalla;
  if (!cierre) return null;

  return (
    <Alert severity={caso === "revisando" ? "info" : "warning"} sx={{ borderRadius: "12px", ...sx }}>
      <AlertTitle sx={{ fontWeight: 700 }}>{aviso.titulo}</AlertTitle>
      {aviso.texto} {cierre}
      {!enFormulario && (
        <Box mt={1.5}>
          <Button
            variant="contained"
            size="small"
            onClick={() => navigate("/mi-perfil?seccion=pagos")}
            sx={{ textTransform: "none", fontWeight: 700 }}
          >
            Ir a Datos para pagos
          </Button>
        </Box>
      )}
    </Alert>
  );
};

export default AvisoCobro;
